import { render, staticRenderFns } from "./PublicidadOverlay.vue?vue&type=template&id=27d71b20"
import script from "./PublicidadOverlay.vue?vue&type=script&lang=js"
export * from "./PublicidadOverlay.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports